export default "__VITE_ASSET__b6d53bef__"